import { signOut as amplifySignOut } from 'aws-amplify/auth';

import axios, { endpoints } from 'src/lib/axios';

import { getErrorMessage } from 'src/auth/utils';

import { setSession, clearAllAuthData } from './utils';
// ----------------------------------------------------------------------

export type SignInParams = {
  email: string;
  password: string;
};

/** **************************************
 * Sign in
 *************************************** */
export const signInWithPassword = async ({ email, password }: SignInParams): Promise<void> => {
  try {
    const params = { email, password };

    const res = await axios.post(endpoints.auth.signIn, params);

    const { accessToken } = res.data;

    if (!accessToken) {
      throw new Error('Access token not found in response');
    }

    setSession(accessToken);
  } catch (error) {
    getErrorMessage(error);
    throw error;
  }
};
/** **************************************
 * Sign out
 *************************************** */
export const signOut = async (): Promise<void> => {
  try {
    await amplifySignOut();
    clearAllAuthData();
  } catch (error) {
    getErrorMessage(error);
    clearAllAuthData();
    throw error;
  }
};
